import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './ui-games-grid.css?inline';

const CName = 'ui-games-grid';

@customElement(CName)
export class UiGamesGrid extends LitElement {
  static readonly styles = unsafeCSS(styles);

  render() {
    return html`
      <div class="ui-games-grid" role="list">
        <slot @slotchange=${this._onSlotChange}></slot>
      </div>
    `;
  }

  private _onSlotChange(e: Event) {
    const slot = e.target as HTMLSlotElement;
    for (const node of slot.assignedElements()) {
      if (!node.getAttribute('role')) {
        node.setAttribute('role', 'listitem');
      }
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiGamesGrid;
  }
}
